import { render, staticRenderFns } from "./faqIntroduction.vue?vue&type=template&id=2d9202a7&"
import script from "./faqIntroduction.vue?vue&type=script&lang=js&"
export * from "./faqIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./faqIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports